import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'userWorkflowDocumentId';
const QS_TYPE: QueryStateSchema['type'] = 'userWorkflowDocument';

export const useOpenUserWorkflowDocumentPane = (): ((args: { userWorkflowDocumentId: string }) => void) => {
  const [userWorkflowDocumentIdDeprecated, setUserWorkflowDocumentId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (userWorkflowDocumentIdDeprecated) {
      setUserWorkflowDocumentId(null);
      setState(backwardsCompatabilityFactory({ id: userWorkflowDocumentIdDeprecated, type: QS_TYPE }));
    }
  }, [userWorkflowDocumentIdDeprecated]);

  return ({ userWorkflowDocumentId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: userWorkflowDocumentId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
